angular.
module("dx.webapp.node").
constant("DX_DEPRECATION_SETTING", Object.freeze({
	UNMODIFIED: 0,
	ALLOW_ALL: 1,
	OVERRIDE: 2,
	APPEND: 3,
}));
